import styled, { css } from "styled-components";
import { borderRadius, spacing, typographyMixin } from "@magicbi/ui-library";

const box = css`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  width: 100%;
  min-width: 0;
  height: 2.375rem;
  padding: ${spacing[0.5]} ${spacing[2]} ${spacing[0.5]} ${spacing[1]};
  border: 1px solid ${({ theme }) => theme.colors.border.stroke};
  border-radius: ${borderRadius.lg};
  background: ${({ theme }) => theme.colors.surface.primary};
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: left;
`;

export const ChipButton = styled.button<{ $error: boolean }>`
  ${box}
  cursor: pointer;

  &:hover,
  &[aria-expanded="true"] {
    border-color: ${({ theme }) => theme.colors.primary[200]};
    background: ${({ theme }) => theme.colors.surface.secondary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary[500]};
    outline-offset: ${spacing[0.5]};
  }

  ${({ $error }) =>
    $error &&
    css`
      border-color: ${({ theme }) => theme.colors.error.text};
      background: ${({ theme }) => theme.colors.error[50]};
    `}

  > svg {
    flex: none;
    width: 0.75rem;
    height: 0.75rem;
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`;

export const ChipStatic = styled.div`
  ${box}
`;

export const Visual = styled.span`
  display: block;
  flex: none;
  width: 5.25rem;
  max-height: 2rem;
  overflow: hidden;
`;

export const Text = styled.span`
  display: grid;
  flex: 1;
  min-width: 0;
`;

export const Title = styled.span`
  ${typographyMixin("caption", 1)}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Subtitle = styled.span<{ $error: boolean }>`
  ${typographyMixin("caption", 4)}
  color: ${({ theme, $error }) => ($error ? theme.colors.error.text : theme.colors.text.secondary)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
